var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSaleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2381 3.80952V9.52381H13.7143V4.57143L9.90476 1.90476L6.09524 4.57143V5.71429H4.57143V3.80952L9.90476 0L15.2381 3.80952ZM11.0476 4.19048H10.2857V4.95238H11.0476V4.19048ZM9.52381 4.19048H8.7619V4.95238H9.52381V4.19048ZM11.0476 5.71429H10.2857V6.47619H11.0476V5.71429ZM9.52381 5.71429H8.7619V6.47619H9.52381V5.71429ZM13.7143 11.0476H12.1905C12.1905 10.1333 11.619 9.31048 10.7657 8.99048L6.07238 7.2381H0V15.619H4.57143V14.5219L9.90476 16L16 14.0952V13.3333C16 12.0686 14.979 11.0476 13.7143 11.0476ZM1.52381 14.0952V8.7619H3.04762V14.0952H1.52381ZM9.88191 14.4076L4.57143 12.9371V8.7619H5.7981L10.2324 10.4152C10.4914 10.5143 10.6667 10.7657 10.6667 11.0476C10.6667 11.0476 9.15048 11.0095 8.91429 10.9333L7.10095 10.3314L6.62095 11.779L8.43429 12.381C8.82286 12.5105 9.22667 12.579 9.63809 12.579H13.7143C14.0114 12.579 14.2781 12.7543 14.4 13.0057L9.88191 14.4076Z",
    fill: "#494949"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaleIcon);
export default __webpack_public_path__ + "static/media/SaleIcon.430111fe3dc236d40f3a19d126a4f434.svg";
export { ForwardRef as ReactComponent };